module.exports = __webpack_public_path__ + "static/media/man-withdrawing-money-from-smartphone.a0a51472.png";